import { computed, inject, Injectable } from '@angular/core';
import { permissionsForRole } from '../models/entities/agent-role.model';
import { AuthSessionService } from './auth-session.service';

/** UI access helpers derived from the signed-in agent's role permissions. */
@Injectable({ providedIn: 'root' })
export class AgentAccessService {
  private readonly auth = inject(AuthSessionService);

  readonly permissions = computed(() =>
    permissionsForRole(this.auth.role(), this.auth.backendPermissions()),
  );

  readonly canRaise = computed(() => this.permissions().raiseToResolve);
  readonly canPark = computed(() => this.permissions().parkEvent);
  readonly canClose = computed(() => this.permissions().closeEvent);
  readonly canArmDisarmSite = computed(() => this.permissions().armDisarmSite);
  readonly canArmDisarmCamera = computed(() => this.permissions().armDisarmCamera);
  readonly canAttachSnapshot = computed(() => this.permissions().attachSnapshot);
  readonly canAttachAlarmClip = computed(() => this.permissions().attachAlarmClip);
  readonly canAddBrowserTab = computed(() => this.permissions().addBrowserTab);
  readonly canAccessEventsDashboard = computed(() => this.permissions().accessEventsDashboard);
  /**
   * Escalation opens the same events dashboard and only sees Armed and Disarmed Sites.
   * `canAccessEventsDashboard` stays false so queue, auto-process, and other operator tools stay off.
   */
  readonly canOpenEventsDashboard = computed(
    () => this.canAccessEventsDashboard() || this.auth.role() === 'Escalation',
  );
  /** Role-based: Escalation never sees the queue toggle, even if backend grants dashboard access. */
  readonly canShowEventQueueToggle = computed(() => this.auth.shouldManageEvents());
}
